var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "icon-container" }, [
    _c(
      "div",
      { staticClass: "icon", class: `name-${_vm.icon}` },
      [
        _vm.icon === "arrow"
          ? [
              _c(
                "svg",
                {
                  staticStyle: { "enable-background": "new 0 0 50 50" },
                  attrs: {
                    version: "1.1",
                    xmlns: "http://www.w3.org/2000/svg",
                    "xmlns:xlink": "http://www.w3.org/1999/xlink",
                    x: "0px",
                    y: "0px",
                    viewBox: "0 0 50 50",
                    "xml:space": "preserve",
                  },
                },
                [
                  _c("line", {
                    staticClass: "ls",
                    attrs: {
                      x1: "16.618",
                      y1: "7.895",
                      x2: "33.382",
                      y2: "25",
                    },
                  }),
                  _vm._v(" "),
                  _c("line", {
                    staticClass: "ls",
                    attrs: {
                      x1: "16.618",
                      y1: "42.105",
                      x2: "33.382",
                      y2: "25",
                    },
                  }),
                ]
              ),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.icon === "tail-arrow-right"
          ? [
              _c(
                "svg",
                {
                  staticStyle: { "enable-background": "new 0 0 50 50" },
                  attrs: {
                    version: "1.1",
                    xmlns: "http://www.w3.org/2000/svg",
                    "xmlns:xlink": "http://www.w3.org/1999/xlink",
                    x: "0px",
                    y: "0px",
                    viewBox: "0 0 50 50",
                    "xml:space": "preserve",
                  },
                },
                [
                  _c("line", {
                    staticClass: "ls",
                    attrs: {
                      x1: "27.952",
                      y1: "13.486",
                      x2: "39.349",
                      y2: "25.116",
                    },
                  }),
                  _vm._v(" "),
                  _c("line", {
                    staticClass: "ls",
                    attrs: {
                      x1: "27.952",
                      y1: "36.746",
                      x2: "39.349",
                      y2: "25.116",
                    },
                  }),
                  _vm._v(" "),
                  _c("line", {
                    staticClass: "ls",
                    attrs: {
                      x1: "38.651",
                      y1: "25.116",
                      x2: "10.651",
                      y2: "25.116",
                    },
                  }),
                ]
              ),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.icon === "tail-arrow-down"
          ? [
              _c(
                "svg",
                {
                  staticStyle: { "enable-background": "new 0 0 50 50" },
                  attrs: {
                    id: "Layer_1",
                    version: "1.1",
                    xmlns: "http://www.w3.org/2000/svg",
                    "xmlns:xlink": "http://www.w3.org/1999/xlink",
                    x: "0px",
                    y: "0px",
                    viewBox: "0 0 50 50",
                    "xml:space": "preserve",
                  },
                },
                [
                  _c("line", {
                    staticClass: "ls",
                    attrs: {
                      x1: "36.63",
                      y1: "28.068",
                      x2: "25",
                      y2: "39.465",
                    },
                  }),
                  _vm._v(" "),
                  _c("line", {
                    staticClass: "ls",
                    attrs: {
                      x1: "13.37",
                      y1: "28.068",
                      x2: "25",
                      y2: "39.465",
                    },
                  }),
                  _vm._v(" "),
                  _c("line", {
                    staticClass: "ls",
                    attrs: { x1: "25", y1: "38.767", x2: "25", y2: "10.767" },
                  }),
                ]
              ),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.icon === "triangle-right"
          ? [
              _c(
                "svg",
                {
                  staticStyle: { "enable-background": "new 0 0 50 50" },
                  attrs: {
                    version: "1.1",
                    xmlns: "http://www.w3.org/2000/svg",
                    "xmlns:xlink": "http://www.w3.org/1999/xlink",
                    x: "0px",
                    y: "0px",
                    viewBox: "0 0 50 50",
                    "xml:space": "preserve",
                  },
                },
                [
                  _c("polygon", {
                    staticClass: "pf",
                    attrs: {
                      points: "14.849,8.987 14.849,39.678 36.072,24.332 ",
                    },
                  }),
                ]
              ),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.icon === "external-link"
          ? [
              _c(
                "svg",
                {
                  staticStyle: { "enable-background": "new 0 0 50 50" },
                  attrs: {
                    version: "1.1",
                    xmlns: "http://www.w3.org/2000/svg",
                    "xmlns:xlink": "http://www.w3.org/1999/xlink",
                    x: "0px",
                    y: "0px",
                    viewBox: "0 0 50 50",
                    "xml:space": "preserve",
                  },
                },
                [
                  _c("g", [
                    _c("polyline", {
                      staticClass: "ls",
                      attrs: {
                        points:
                          "44.157,32 44.157,44.157 5.843,44.157 5.843,5.843 18,5.843 \t",
                      },
                    }),
                    _vm._v(" "),
                    _c("line", {
                      staticClass: "ls",
                      attrs: { x1: "25", y1: "25", x2: "44.157", y2: "5.843" },
                    }),
                    _vm._v(" "),
                    _c("line", {
                      staticClass: "ls",
                      attrs: {
                        x1: "32",
                        y1: "5.843",
                        x2: "44.157",
                        y2: "5.843",
                      },
                    }),
                    _vm._v(" "),
                    _c("line", {
                      staticClass: "ls",
                      attrs: {
                        x1: "44.157",
                        y1: "18",
                        x2: "44.157",
                        y2: "5.843",
                      },
                    }),
                  ]),
                ]
              ),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.icon === "loading-circle"
          ? [
              _c(
                "svg",
                {
                  staticClass: "loading",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "100",
                    height: "100",
                    viewBox: "0 0 100 100",
                  },
                },
                [
                  _c("circle", {
                    staticClass: "cr",
                    attrs: { cx: "50", cy: "50", r: "40" },
                  }),
                ]
              ),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.icon === "loading-circle-gradient"
          ? [_c("div", { staticClass: "loading-circle-gradient" })]
          : _vm._e(),
        _vm._v(" "),
        _vm.icon === "phone"
          ? [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 27.107 27.238",
                  },
                },
                [
                  _c("path", {
                    staticClass: "sf",
                    attrs: {
                      d: "M31.95,12.064,28.7,15.446a2.124,2.124,0,0,0,0,3.122l2.6,2.6a21.713,21.713,0,0,1-9.366,9.366l-2.6-2.6a2.124,2.124,0,0,0-3.122,0l-3.382,3.252a2.55,2.55,0,0,0,0,3.252L16.21,37.69C21.8,43.414,44.048,21.04,38.454,15.446L35.2,12.064A2.276,2.276,0,0,0,31.95,12.064Z",
                      transform: "translate(-12.242 -11.381)",
                    },
                  }),
                ]
              ),
            ]
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }